__webpack_require__.hmrF = function() { return "core." + __webpack_require__.h() + ".hot-update.json"; };